import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts';
import { useQuiz } from '../hooks';
import { LoadingScreen, LanguageSelector } from '../components/common';
import { QuestionCard } from '../components/quiz';

const QuizPage: React.FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const navigate = useNavigate();
  const {
    currentQuestion,
    currentIndex,
    totalQuestions,
    loading,
    submitting,
    result,
    answers,
    handleAnswer,
  } = useQuiz();

  // Redirect to result page when result is ready
  React.useEffect(() => {
    if (result) {
      navigate('/result', { state: { result, answers } });
    }
  }, [result, answers, navigate]);

  if (loading) return <LoadingScreen />;

  if (submitting) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block w-10 h-10 border-4 border-scaleo-blue border-t-transparent rounded-full animate-spin mb-4" />
          <p className="text-gray-500 text-sm font-medium">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (!currentQuestion) return <LoadingScreen />;

  return (
    <div className="min-h-screen bg-gray-50" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Language selector */}
      <div className="flex justify-end p-4">
        <LanguageSelector />
      </div>

      {/* Quiz content */}
      <div className="max-w-lg mx-auto px-4 pb-12">
        <QuestionCard
          question={currentQuestion}
          currentIndex={currentIndex}
          totalQuestions={totalQuestions}
          onAnswer={handleAnswer}
        />
      </div>
    </div>
  );
};

export default QuizPage;
